import { CHATBOT_ID } from '../../constants/chatbotId';
import { TMessageSchema } from '../../types/messages';

interface IIsMessageOutcomingParams {
  rawMessage: TMessageSchema;
  userId: number;
}

/** Определяет, является ли сообщение исходящим для текущего пользователя. */
export function isMessageOutcoming({ rawMessage, userId }: IIsMessageOutcomingParams): boolean {
  return Boolean(rawMessage.userId === userId || (rawMessage.chatId === CHATBOT_ID && !rawMessage.fromChatBot));
}
